// The four cards of the picker (AC1). ACA-266 builds this list, and ACA-267
// (Artist), ACA-268 (Collector) and ACA-269 (Jewelry) consume it rather than
// restating it: one picker, one list, four tickets.
//
// Copy, order and photography are the signed design's — App Onboarding.dc.html,
// `const ROLES`. The ids are the design's too, and deliberately are not the
// `User.*` enum: Type.jsx has named exports that global.d.ts does not declare
// (allowJs is false), so a TypeScript module cannot import them. The mapping
// from a PersonaId to a signup type stays in page/Onboarding.jsx, which already
// owns the Jewelry coercion.

export type PersonaId = "gallery" | "artist" | "collector" | "jewelry";

export interface PersonaOption {
  id: PersonaId;
  label: string;
  blurb: string;
  /** Served from wwwroot. The card crops it to 4:3 with object-fit: cover. */
  image: string;
}

export const PERSONA_OPTIONS: readonly PersonaOption[] = [
  {
    id: "gallery",
    label: "Gallery",
    blurb: "Manage inventory, consignments and collectors.",
    image: "/assets/img/onboarding/role/role-gallery.jpg",
  },
  {
    id: "artist",
    label: "Artist",
    blurb: "Track your works and consign them to galleries.",
    image: "/assets/img/onboarding/role/role-artist.jpg",
  },
  {
    id: "collector",
    label: "Collector",
    blurb: "Catalogue the works you own.",
    image: "/assets/img/onboarding/role/role-collector.jpg",
  },
  {
    id: "jewelry",
    label: "Jewelry",
    blurb: "Run stock, pricing and certificates.",
    image: "/assets/img/onboarding/role/role-jewelry.jpg",
  },
] as const;
